import {
  DeliveryType,
  PickupDeliveryFeeType,
  TicketStatus
} from 'src/app/models';

interface PickupDeliveryFeeMapperValue {
  type: PickupDeliveryFeeType;
  name: string;
}

type PaymentStatusName =
  | 'Open'
  | 'Partial Paid'
  | 'Closed'
  | 'Cancelled'
  | 'Voided';

export class TicketConstant {
  static readonly ABLE_ADD_NEW_ITEM_STATUS = [
    TicketStatus.EMPTY,
    TicketStatus.IN_PROGRESS
  ];

  static readonly PICKUP_DELIVERY_FEE_MAPPER: Record<
    DeliveryType,
    PickupDeliveryFeeMapperValue
  > = {
    [DeliveryType.DELIVERY]: { name: 'Delivery Fee', type: 'delivery' },
    [DeliveryType.TO_GO]: { name: 'Takeout Fee', type: 'pick_up' },
    [DeliveryType.PICK_UP]: { name: 'Pickup Fee', type: 'pick_up' },
    [DeliveryType.TO_TABLE]: null,
    [DeliveryType.TO_ROOM]: null,
    [DeliveryType.TO_SEAT]: null
  };

  private static readonly DEFAULT_STYLE = {
    backgroundColor: '#e8f5e9',
    color: '#43a047'
  };

  private static readonly CLOSED_STYLE = {
    backgroundColor: '#eceff1',
    color: '#607d8b'
  };

  static readonly TICKET_STATUS_MAPPER: Record<
    TicketStatus,
    {
      paymentStatusName: PaymentStatusName;
      style?: {
        backgroundColor: string;
        color: string;
      };
    }
  > = {
    [TicketStatus.EMPTY]: {
      paymentStatusName: 'Open',
      style: TicketConstant.DEFAULT_STYLE
    },
    [TicketStatus.IN_PROGRESS]: {
      paymentStatusName: 'Open',
      style: TicketConstant.DEFAULT_STYLE
    },
    [TicketStatus.PARTIAL_PAID]: {
      paymentStatusName: 'Partial Paid',
      style: {
        color: '#c68305',
        backgroundColor: 'rgba(237, 181, 64, 0.16)'
      }
    },
    [TicketStatus.PAID]: {
      paymentStatusName: 'Open',
      style: TicketConstant.DEFAULT_STYLE
    },
    [TicketStatus.CLOSED]: {
      paymentStatusName: 'Closed',
      style: TicketConstant.CLOSED_STYLE
    },
    [TicketStatus.PARTIAL_REFUND]: {
      paymentStatusName: 'Closed',
      style: TicketConstant.CLOSED_STYLE
    },
    [TicketStatus.FULL_REFUND]: {
      paymentStatusName: 'Closed',
      style: TicketConstant.CLOSED_STYLE
    },
    [TicketStatus.CANCELLED]: {
      paymentStatusName: 'Cancelled',
      style: TicketConstant.DEFAULT_STYLE
    },
    [TicketStatus.VOIDED]: {
      paymentStatusName: 'Voided',
      style: {
        backgroundColor: '#feebee',
        color: '#ef5350'
      }
    },
    [TicketStatus.IS_REFUND]: {
      paymentStatusName: 'Open',
      style: TicketConstant.DEFAULT_STYLE
    },
    [TicketStatus.TAKEOUT_ORDER_IN_PROGRESS]: {
      paymentStatusName: 'Open',
      style: TicketConstant.DEFAULT_STYLE
    }
  };

  static readonly CLOSED_TICKET_STATUS_LIST = [
    TicketStatus.PARTIAL_REFUND,
    TicketStatus.FULL_REFUND,
    TicketStatus.CLOSED,
    TicketStatus.VOIDED,
    TicketStatus.CANCELLED
  ];
}
